// extracted by mini-css-extract-plugin
module.exports = {"mainElementsItem":"burger-constructor-item_mainElementsItem__z0Vow","dragIcon":"burger-constructor-item_dragIcon__28n0u"};